import { getCookie, removeCookies, setCookies, setCookie } from 'cookies-next';
import { isCrawler, isServer } from './isServer';
import dayjs from 'dayjs';

// Prod
export const GTM_ID = 'GTM-PQ3LLKT';
export const UA_ID = 'UA-106538319-1';
export const AW_ID = 'AW-925699234';
export const OPTIMIZE_ID = 'GTM-5WPX3W7';
export const CLICKY_ID = '101415382';
export const CLICKY_GOAL_ID = '2861';
// Dev
/*
export const GTM_ID = 'GTM-PVMV7M5';
export const UA_ID = 'UA-93814301-1';
export const AW_ID = 'AW-665';
export const OPTIMIZE_ID = 'OPT-MG2NXPD';
export const CLICKY_ID = "101415382";
export const CLICKY_GOAL_ID = '2861';
*/

export const INTERFACE_RATE = () => {
  return process.env.AB3_RATE || -1;
};
export const randomABCookie = (tag, rate, reqres) => {
  if (rate == -1) return 2;
  if (reqres.req?.headers && isCrawler(reqres.req.headers['user-agent'])) {
    return 2;
  }
  if (!rate) rate = 0.1;
  const ab = getCookie(tag, reqres);
  if (ab) {
    setCookies(tag, ab, { ...reqres, maxAge: 60 * 60 * 5 });
    return ab;
  }
  const abSelect = Math.random() < rate ? 1 : 2;
  setCookies(tag, abSelect, { ...reqres, maxAge: 60 * 60 * 5 });
  return abSelect;
};

export const randomABTag = (tag, save) => {
  const ab = sessionStorage.getItem(tag);
  if (ab) return ab;
  const abSelect = Math.random() > 0.5 ? 1 : 2;
  if (save) {
    sessionStorage.setItem(tag, abSelect);
  }
  return abSelect;
};

export const synthetic = (ev, it) => {
  try {
    let data = [];
    try {
      data = JSON.parse(sessionStorage.getItem('synthetic'));
      if (!data) data = [];
    } catch (e) {
      data = [];
    }
    data.push([new Date().toISOString(), ev, it]);
    sessionStorage.setItem('synthetic', JSON.stringify(data));
  } catch (e) {;}
};

export const parseUrlData = (router) => {
  if (!isServer) {
    if (router.query?.static_email_parameter) {
      sessionStorage.setItem(
        'static_email_parameter',
        router.query?.static_email_parameter
      );
      sessionStorage.setItem(
        'static_first_name_parameter',
        router.query?.static_first_name_parameter
      );
      sessionStorage.setItem(
        'static_last_name_parameter',
        router.query?.static_last_name_parameter
      );
      if (router.query?.checkin) {
        sessionStorage.setItem('checkin', router.query.checkin);
      }
      if (router.query?.checkout) {
        sessionStorage.setItem('checkout', router.query.checkout);
      }
    }
  }
};

export const pageview = (url) => {
  const dim5abData = 0; //sessionStorage.getItem('dim5ab') ? sessionStorage.getItem('dim5ab') : 0;
  const dim3abData = 0; //getCookie('dim3ab') ? getCookie('dim3ab') : 2;
  const dim4abData = 0; // getCookie('dim4ab') ? getCookie('dim4ab') :
  const pos = url.indexOf('?');
  if (pos > 0 && url.indexOf('/checkout') == -1) {
    url = url.substring(0, pos);
  }
  window.dataLayer?.push({
    event: 'pageview',
    page: url,
    dim5_ab: dim5abData,
    dim4_ab: dim4abData,
    dim3_ab: dim3abData,
  });
  synthetic('pv', url);
};

//    pushAutoEvent('onboarding', 'openModal', 'open')
export const pushAutoEvent = (category, action, label) => {
  window.dataLayer?.push({
    event: 'event-to-ga',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  });
};

function formatNumberDecimal(nb) {
  try {
    if (nb) {
      return '' + parseFloat(nb).toFixed(2);
    }
  } catch (e) {
    return '0.00';
  }
  return '0.00';
}

const loadTransactions = () => {
  try {
    const ck = getCookie('oa_trans');
    return ck.split(',');
  } catch (e) {
    return [];
  }
};
const saveTransactions = (arr) => {
  try {
    setCookie('oa_trans', arr.join(','), { maxAge: 7776000 });
    return 0;
  } catch (e) {
    return 0;
  }
};

function mapItemCategory(parkingType) {
  if (parkingType==2) {
    return "CP"
  }
  if (parkingType==3) {
    return "HP"
  }
  if (parkingType==1) {
    return "CR"
  }
  return "AP";
}

export const checkTransaction = (code) => {
  const currentTransactions = loadTransactions();
  return currentTransactions.includes(code);
}

export const pushPurchaseEvent = (result) => {
  if (!result?.reservation_code) return;
  const currentTransactions = loadTransactions();
  if (currentTransactions.includes(result?.reservation_code)) {
    return;
  }
  let prefix = ""
  if (result?.facility_url_code?.startsWith("rl_")) {
    prefix = "RL "
  }
  if (result?.facility_url_code?.startsWith("arv_")) {
    prefix = "ARV "
  }
  let days_until_park = undefined;
  try {
    days_until_park = dayjs(result?.reservation_dt_checkin).startOf('day').diff(dayjs().startOf('day'),'day',true)
  }
  catch (e){;}
  const data = {
    transaction_id: result?.reservation_code,
    value: formatNumberDecimal(result?.amount_to_noson),
    currency: 'USD',
    coupon: result?.coupon_code ? result?.coupon_code : undefined,
    items: [
      {
        item_id: result?.reservation_code,
        item_name: result?.airport_initials,
        item_category: mapItemCategory(result?.facilityParkingType),
        item_category2: result?.daily_rate ? formatNumberDecimal(result?.daily_rate) : undefined,
        item_category3: result?.days_parked ? result?.days_parked : undefined,
        item_category4: days_until_park,
        coupon: result?.coupon_code ? result?.coupon_code : undefined,
        discount: result?.coupon_code
          ? formatNumberDecimal(result?.coupon_discount)
          : undefined,
        item_brand: result?.branded ? 'branded' : 'non branded',
        item_variant: prefix + result?.facility_name,
        price: formatNumberDecimal(result?.amount_to_noson),
      },
    ],
  };
  window.dataLayer?.push({ event: 'purchase', ecommerce: data });

	window.uetq = window.uetq || [];
	window.uetq.push('event', 'purchase', { 
		transaction_id: result?.reservation_code,
		ecomm_prodid: [result?.airport_initials], 
		ecomm_pagetype: 'purchase',
		ecomm_totalvalue: formatNumberDecimal(result?.amount_to_noson),
		revenue_value: formatNumberDecimal(result?.amount_to_noson),
		currency: 'USD',
		items: [ 
		    { 
		       id : result?.reservation_code,
		       quantity : 1,
		       price : formatNumberDecimal(result?.amount_to_noson) 
		    }, 
		  ] 
		}
	);
  window.uetq.push("event", 
    "PRODUCT_PURCHASE", 
    {
      "ecomm_prodid":result?.reservation_code,
      "ecomm_pagetype":"PURCHASE",
      "revenue_value":formatNumberDecimal(result?.amount_to_noson),
      "currency":"USD"
    })

  try{ 
    window.oaiq(  "measure",
      "order_created",
      { 
        type: "contents",
        amount: parseInt((result?.amount_to_noson*100).toFixed(0)),
        currency: "USD",
      }
    )
  }
  catch(e) {;}

  currentTransactions.push(result?.reservation_code);
  saveTransactions(currentTransactions);
};
export const pushLayerEvent = (event, params = null) => {
  const dim5abData = 0; // sessionStorage.getItem('dim5ab') ? sessionStorage.getItem('dim5ab') : 0;
  const dim3abData = 0; // getCookie('dim3ab') ? getCookie('dim3ab') : 2;
  const dim4abData = 0; // getCookie('dim4ab') ? getCookie('dim4ab') : 0;
  if (event !== 'conversion') {
    window.dataLayer?.push({
      event: event,
      facility_id: params?.facility_id,
      dim5_ab: dim5abData,
      dim4_ab: dim4abData,
      dim3_ab: dim3abData,
    });
  }

  window.dataLayer?.push({
    event: 'VirtualPageView',
    virtualPageURL: '/virtualpage/' + event,
    facility_id: params?.facility_id,
    dim5_ab: dim5abData,
    dim4_ab: dim4abData,
    dim3_ab: dim3abData,
  });

  window.dataLayer?.push({
    event: 'pageview',
    page: '/virtualpage/' + event,
    facility_id: params?.facility_id,
    dim5_ab: dim5abData,
    dim4_ab: dim4abData,
    dim3_ab: dim3abData,
  });

  window.mixpanel?.track(event, {
    facility_id: params?.facility_id,
    dim5_ab: dim5abData,
    dim4_ab: dim4abData,
    dim3_ab: dim3abData,
  });

  if (event === 'conversion') {
    window.dataLayer?.push({
      event: event,
      send_to: params?.send_to,
      value: params?.value,
      currency: params?.currency,
      facility_id: params?.facility_id,
      facility_name: params?.facility_name,
      market: params?.market,
      reservation_code: params?.reservation_code,
      order_id: params?.order_id,
      order_value: params?.order_value,
      user_data: params?.user_data,
    });
    if (window.clicky) {
      window.clicky.goal(CLICKY_GOAL_ID, '0');
    }
  }
};

